import React, { useEffect, useMemo, useRef } from 'react';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import { useAuth } from 'contexts/AuthContext';
import { useProgress } from '../../hooks/course/useProgress';

interface ContentVideoProps {
  id: string;
  courseId: string;
  url: string;
  thumbnail: string;
  title: string;
  description: string;
}

const ContentVideo: React.FC<ContentVideoProps> = ({
  id,
  courseId,
  url,
  thumbnail,
  title,
  description,
}) => {
  const { user } = useAuth();
  const { completeLesson, loading, isLessonCompleted, fetchProgress } = useProgress(courseId);
  const [locallyCompleted, setLocallyCompleted] = React.useState(false);

  const hasFetchedRef = useRef(false);

  useEffect(() => {
    if (hasFetchedRef.current) return;

    hasFetchedRef.current = true;
    fetchProgress();
  }, []);

  useEffect(() => {
    const completedFromProgress = isLessonCompleted(id);
    setLocallyCompleted(completedFromProgress);
  }, [id, isLessonCompleted]);


  const completed = locallyCompleted;

  const handleComplete = async () => {
    setLocallyCompleted(true);
    await completeLesson(id);
  };

  if (!user) return null;


  return (
    <>
      {/* Player */}
      <div className="bg-black rounded-xl overflow-hidden aspect-video">
        {url && <VideoPlayer key={id} url={url} poster={thumbnail} />}
      </div>

      {/* Video Info */}
      <div className="mt-4 bg-white rounded-xl p-6 shadow-sm">
        <div className="flex justify-between items-start">
          <div className="flex-1">
            <h2 className="text-xl font-semibold text-gray-900 mb-2">
              {title}
            </h2>
            <p className="text-gray-600">{description}</p>
          </div>

          <button
            onClick={handleComplete}
            disabled={loading || completed}
            className={`ml-4 px-4 py-2 rounded-lg font-medium transition-all flex items-center gap-2 ${
              completed
                ? 'bg-green-100 text-green-700'
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            } ${loading ? 'opacity-60 cursor-not-allowed' : ''}`}
          >
            {completed ? '✓ Concluída' : 'Marcar como concluída'}
          </button>
        </div>
      </div>
    </>
  );
};

export default ContentVideo;